import { useController } from '../../hooks/useController'

import { ErrorFooter } from './components/ErrorFooter'
import { SuccessFooter } from './components/SuccessFooter'

export function Footer() {
  const { status } = useController()

  switch (status) {
    case 'success':
      return <SuccessFooter />

    case 'error':
      return <ErrorFooter />
  }
}
